import React, {Component} from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import {Container, Header, Segment, Image, Grid} from 'semantic-ui-react';

const coverImage = require('../assets/img/building.jpeg');
const clientsImage = require('../assets/img/clientes.png');
const cupImage = require('../assets/img/cup.png');
const coverStyle = {
  backgroundColor: 'black',
  backgroundImage: `url(${coverImage})`,
  backgroundSize: 'cover',
  backgroundAttachment: 'fixed',
  
};
const mainSegmentStyle = {
  height: '70vh',
  background: 'rgba(0,0,0,0)',
  backgroundColor: 'hsl(0, 0%, 100%)',
  mixBlendMode: 'screen',
  marginBottom: '50vh'
};
const headerStyle = {
  textTransform: 'uppercase',
  textShadow: 'rgb(152, 152, 152) 9px 4px 0px',  
  color: 'black',

  position: 'absolute',
  bottom: 20,
  width: '100%',
  left: 0,
  right: 0
};
const subheaderStyle = {
  color: 'black',
  textShadow: 'none'
};
const mainStyle = {
  backgroundColor: '#f0b71d',
  marginBottom: '0'
};
const secondaryHeaderStyle = {
  color: 'orange',
  display: 'inline-block',
  fontSize: '30pt'
};
const textStyle = {
  fontSize: '16pt'
}
class TestimonialsView extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (

        <Container fluid style={coverStyle}>
        <Segment basic className="coversegment">
        <center>
          
          <Header as="h1" style={headerStyle}>
          <Header.Subheader style={subheaderStyle}>
              Escuchamos a nuestros clientes
            </Header.Subheader>
            TESTIMONIOS
            
          </Header>
        </center>
        
        </Segment>
        <div>
        <div style={{...coverStyle, filter: 'blur(5px)', position: 'absolute', height: '100%', zIndex: '-1'}}></div>
        <Segment basic style={{marginTop: '0'}}>
                           <blockquote>
                    <p>
                      Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo.
                      <br/>

                    </p>
                    <em>– Client Name – Company</em>
                  </blockquote>
        </Segment>
        
        </div>
        
        <Segment basic style={{backgroundColor: '#f0b71d', marginTop: '15vh'}}>
                           <blockquote>
                    <p>
                      Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit amet, ante. Donec eu libero sit amet quam egestas semper. Aenean ultricies mi vitae est. Mauris placerat eleifend leo.
                      <br/>

                    </p>
                    <em>– Client Name – Company</em>
                  </blockquote>
        </Segment>
        </Container>
      
    );
  }
}

export default TestimonialsView;



// WEBPACK FOOTER //
// ./client/containers/TestimonialsView.js